import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from 'src/_config/config';

@Component({
  selector: 'app-range-type',
  templateUrl: './range-type.component.html',
  styleUrls: ['./range-type.component.scss'],
  providers: [DatePipe],
})
export class RangeTypeComponent implements OnInit {
  @Output() formEvent = new EventEmitter<any>();

  rangeGroup = new FormGroup({
    rangeType: new FormControl('12-months'),
    dateRange: new FormControl<any>(null),
  });

  selectDatesText = 'Select Dates';

  private subscriptions = new Subscription();

  constructor(public datepipe: DatePipe) {}

  ngOnInit(): void {
    this.formEvent.emit(this.rangeGroup.getRawValue());

    this.subscriptions.add(
      this.rangeGroup.get('rangeType')?.valueChanges.subscribe(() => {
        this.selectDatesText = 'Select Dates';

        this.formEvent.emit(this.rangeGroup.getRawValue());
      })
    );

    this.subscriptions.add(
      this.rangeGroup.get('dateRange')?.valueChanges.subscribe((item: any) => {
        this.selectDatesText = item.end
          ? `${this.datepipe.transform(
              item.start,
              APP_CONFIG.dateFormat
            )} - ${this.datepipe.transform(item.end, APP_CONFIG.dateFormat)}`
          : `${this.datepipe.transform(item.start, APP_CONFIG.dateFormat)}`;

        if (!item.end) {
          const dateRange = { start: item.start, end: item.start };

          this.rangeGroup.patchValue({
            rangeType: null,
            dateRange,
          });
        }

        this.formEvent.emit(this.rangeGroup.getRawValue());
      })
    );
  }
}
